import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Home,
  FileText,
  Users,
  User,
  Box,
  Settings,
  ChevronDown,
  ChevronRight,
} from "lucide-react";

export default function Menu() {
  const menuPrivate = [
    { icon: Home, title: "Tableau de bord", link: "/admin/dashboard" },
    { icon: FileText, title: "Tickets", link: "/admin/ticket" },
    { icon: Users, title: "Livreurs", link: "/admin/drivers" },
    { icon: User, title: "Établissements", link: "/admin/etablishments" },
    { icon: Box, title: "Produits", link: "/admin/products" },
    { icon: Settings, title: "Configurations", link: "/admin/settings" },
    { icon: Settings, title: "Comptabilité", link: "/admin/payment" },
  ];

  const menuPublic = [
    { icon: Home, title: "Tableau de bord", link: "/admin/dashboard-public-app" },
    { icon: FileText, title: "Commandes", link: "/admin/public-app-orders" },
    { icon: Users, title: "Utilisateurs", link: "/admin/public-app-users" }
  ];

  const [openSection, setOpenSection] = useState("private");

  const renderMenu = (menuData) =>
    menuData.map((data, key) => {
      const Icon = data.icon;
      return (
        <Link to={data.link} key={key}>
          <li className="dahboardmenu--item">
            <div style={{ display: "flex", alignItems: "center" }}>
              <Icon size={20} style={{ marginRight: 10 }} />
              <span>{data.title}</span>
            </div>
          </li>
        </Link>
      );
    });

  const Section = ({ id, title, children }) => {
    const isOpen = openSection === id;
    return (
      <div>
        <div
          className="menu-section-header"
          onClick={() => setOpenSection(isOpen ? null : id)}
        >
          {title}
          {isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
        </div>
        {isOpen && <ul style={{ margin: 0 }}>{children}</ul>}
      </div>
    );
  };

  return (
    <div className="side-bar dahboardmenu">
      <nav>
        <Section id="private" title="Application privée">
          {renderMenu(menuPrivate)}
        </Section>

        <Section id="public" title="Application publique">
          {renderMenu(menuPublic)}
        </Section>
      </nav>
    </div>
  );
}
